require.register("modules/m03s/m03s-activity/page-17-co/page-17-co", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page17co = _.defaults({
  initialized: function (view) {

  },
  loaded: function (view) {

  },
  playing: function (view) {

  },
  paused: function (view) {

  },
  stopped: function (view) {

  },
  completed: function (view) {
  },
  unloading: function (view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page17co;

  
});

